import { FC } from 'react'
import {
  formatPriceWithCurrency,
  PricePlacement,
  formatNumber,
} from 'utils/format'

interface IProps {
  value: number | string | undefined | null
  currencyCode?: string
  placement?: PricePlacement
  defaultValue?: string
}

const Price: FC<IProps> = ({
  value,
  currencyCode,
  placement = 'right',
  defaultValue = '-',
}) => {
  if (currencyCode) {
    return (
      <>
        {formatPriceWithCurrency(value, currencyCode, placement, {
          defaultValue,
        })}
      </>
    )
  }

  const num =
    value === null || value === undefined || value === ''
      ? undefined
      : typeof value === 'string'
      ? +value.replace(',', '.')
      : value

  return <>{formatNumber(num) ?? defaultValue}</>
}

export default Price
